module Meevo.Plugins.Paging {
    'use strict';

    export interface ISectionParamsPaging {
        sectionId: number;
        displayNameContentKey: string;
        template: string;
        isPrimarySection: boolean;
        handlesOwnCrud: boolean;
        baseEndpoint: string;
        sectionEndpoint: string;
        loggingService: Meevo.Components.Logging.ILoggingService;
        dataService: Meevo.Components.CommonClasses.ICommonDataService;
        context: PagingContext;
        pagingService: Meevo.Plugins.Paging.PagingService;
        identityService: Meevo.Components.Common.IIdentityService;
        busyService: Meevo.Components.Busy.IBusyService;
        noun: Meevo.Model.NounEnum;
        sectionSecurityKey?: string;
    }

    export class PagingBaseSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        protected pagingService: Meevo.Plugins.Paging.PagingService;
        protected context: PagingContext;
        protected busyService: Meevo.Components.Busy.IBusyService;

        constructor(params: ISectionParamsPaging) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.noun,
                params.identityService,
                params.sectionSecurityKey);

            this.pagingService = params.pagingService;
            this.context = params.context;
            this.busyService = params.busyService;
        }


        public activate(): void {
            this.isLoaded = true;
        }

        getResults(url, onPageLoad?) {
            return new Meevo.Components.BaseClasses.PagedResults(this.pagingService.dataService, url, onPageLoad, this.context);
        }
    }
}
